<div class="col-sm-12 coldx" >
	<h4>{{title}}</h4>
	<ng-template [ngIf]="petitumRevisioneForm">
		<form [formGroup]="petitumRevisioneForm" (ngSubmit)="save();">
			<div class="">
				<fieldset class="form-group">
					<legend>Valore economico</legend>
					<div radioButtonInput class="col-sm-12" [nameRadio]="'tipoPetitum'" [classCol]="'col-sm-4'" formControlName="tipoPetitum"
						(change)="request.importoPetitum = undefined; request.compensi = undefined; request.spese = undefined; request.altro = undefined"
						[checkedRadioId]=" request?.tipoPetitum?.id" [radioButtonOptions]="tipiPetitumOptions"
						(onReturn)="request.tipoPetitum = $event" [ngModel]="request.tipoPetitum" [mandatory]="true"
						[edit]="getEdit()">
					</div>
				</fieldset>
			</div>
			<div class="row">
				<div datePickerInput class="col-sm-6"
					[labelInput]="'Data inizio revisione'"
					[submitPending]="request.tipoRevisione && request.tipoRevisione.id == idTipoRevisioneWizard"
					[mandatory]="true" formControlName="dataRevisioneDa" [(ngModel)]="request.dataRevisioneDa"></div>

				<div textInputCurrency class="col-sm-6"
					*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile"
					[labelInput]="'Importo'" formControlName="importoPetitum" [location]="'SezioneEconomica'"
					[control]="petitumRevisioneForm.controls['importoPetitum']" [(ngModel)]="request.importoPetitum">
				</div>

				<!--<div textInputCurrency class="col-sm-4"
					*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile && !recuperoCrediti"
					[labelInput]="'Rivalutazione'" formControlName="rivalutazione" [location]="'SezioneEconomica'"
					[control]="petitumRevisioneForm.controls['rivalutazione']" [(ngModel)]="request.rivalutazione">
				</div>-->
			</div>
			<!--<div class="row">
				<div textInputCurrency class="col-sm-6"
					*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile && recuperoCrediti"
					[location]="'SezioneEconomica'" [labelInput]="'Interessi Spese legali'"
					formControlName="interessiSpeseLegali"
					[control]="petitumRevisioneForm.controls['interessiSpeseLegali']"
					[(ngModel)]="request.interessiSpeseLegali"></div>

				<div textInputCurrency class="col-sm-6"
					*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile && recuperoCrediti"
					[location]="'SezioneEconomica'" [labelInput]="'Maggior danno'" formControlName="maggiorDanno"
					[control]="petitumRevisioneForm.controls['maggiorDanno']" [(ngModel)]="request.maggiorDanno"></div>
			</div>-->
			<!--<div class="row">
				<div textInputCurrency class="col-sm-6"
					*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile"
					[labelInput]="'Compensi professionali'" formControlName="spese" [location]="'SezioneEconomica'"
					[control]="petitumRevisioneForm.controls['spese']" [(ngModel)]="request.spese"></div>

				<div textInputCurrency class="col-sm-6"
					*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile"
					[location]="'SezioneEconomica'"
					[labelInput]="'Spese vive'" formControlName="altro"
					[control]="petitumRevisioneForm.controls['altro']" [(ngModel)]="request.altro"></div>
			</div>-->
			<div class="row">
				<div textAreaInput class="form-group col-sm-12" [labelInput]="'Motivo revisione'"
					formControlName="motivoRevisione" [(ngModel)]="request.motivoRevisione"></div>
			</div>

			<div class="row">
				<p class="mandatory col-sm-12">
					<em>* Campi obbligatori</em>
				</p>
			</div>

			<div class="row">
				<div class="col-sm-3 col-xs-6">
					<p>
						<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset
						</button>
					</p>
				</div>
				<div class="col-sm-3 col-xs-6 col-sm-offset-6">
					<p submitButton [disabled]="!petitumRevisioneForm.valid" [labelButton]="'Salva'"></p>
				</div>
			</div>
		</form>
	</ng-template>
</div>






<!-- <div class="col-sm-12 coldx" >
	<h4>{{title}}</h4>
	<ng-template [ngIf]="petitumRevisioneForm">
	<form [formGroup]="petitumRevisioneForm" (ngSubmit)="save();">
		<div class="row container_conteggi">
			<div radioButtonInput class="col-sm-12" [nameRadio]="'tipoPetitum'"
				formControlName="tipoPetitum"
				(change)="request.importoPetitum = undefined; request.compensi = undefined; request.spese = undefined; request.altro = undefined"
				[checkedRadioId]=" request.tipoPetitum.id"
				[radioButtonOptions] ="tipiPetitumOptions"
				(onReturn)="request.tipoPetitum = $event"
				[ngModel]="request.tipoPetitum"
				[edit]="getEdit()"></div>
		</div>
		<div class="row">
			<div datePickerInput class="col-sm-6"
				[labelInput]="'Data inizio revisione'"
				[submitPending]="request.tipoRevisione && request.tipoRevisione.id == idTipoRevisioneWizard"
				[mandatory]="true" formControlName="dataRevisioneDa"
				[(ngModel)]="request.dataRevisioneDa"></div>

			<div
				*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile"
				class="col-sm-6" textInputCurrency [labelInput]="'Importo Petitum'"
				formControlName="importoPetitum"
				[control]="petitumRevisioneForm.controls['importoPetitum']"
				[location]="'SezioneEconomica'" [(ngModel)]="request.importoPetitum"></div>
		</div>
		<div class="row">
			<div 
				*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile"
				textInputCurrency [labelInput]="'Compensi'"
				formControlName="compensi" class="col-sm-4"
				[control]="petitumRevisioneForm.controls['compensi']"
				[location]="'SezioneEconomica'" [(ngModel)]="request.compensi"></div>
			<div 
				*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile"
				textInputCurrency [labelInput]="'Spese'" formControlName="spese"
				class="col-sm-4" [control]="petitumRevisioneForm.controls['spese']"
				[location]="'SezioneEconomica'" [(ngModel)]="request.spese"></div>
			<div 
				*ngIf="request.tipoPetitum && request.tipoPetitum.id == idPetitumQuantificabile"
				textInputCurrency [labelInput]="'Altro'" formControlName="altro"
				class="col-sm-4" [control]="petitumRevisioneForm.controls['altro']"
				[location]="'SezioneEconomica'" [(ngModel)]="request.altro"></div>
		</div>
		<div class="row">
			<div textAreaInput class="form-group col-sm-12"
				[labelInput]="'Motivo revisione'" formControlName="motivoRevisione"
				[(ngModel)]="request.motivoRevisione"></div>
		</div>

		<div class="row">
			<p class="mandatory col-sm-12">
				<em>* Campi obbligatori</em>
			</p>
		</div>

		<div class="row">
			<div class="col-sm-3 col-xs-3">
				<p>
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="createForm();">Reset</button>
				</p>
			</div>
			<div class="col-sm-3 col-xs-6 col-sm-offset-6">
				<p submitButton [disabled]="!petitumRevisioneForm.valid"
					[labelButton]="'Salva'"></p>
			</div>
		</div>
	</form>
	</ng-template>
</div> -->